export default __webpack_public_path__ + "";